import React, {FC} from "react";
import {KCTEventDto} from "../../types/contracts";

interface EventSelectorComponentProps {
    events: KCTEventDto[];
    selectedValue: string | "";
    onSelect: (eventId: string) => void;
    isLoading: boolean;
}

const EventSelectorComponent: FC<EventSelectorComponentProps> = ({events, onSelect, selectedValue, isLoading}) => {
    return (
        <div className="flex justify-center md:justify-between items-center">
            <label
                className="block mb-1 px-2 font-semibold"
                htmlFor="existing-events"
            >
                Akce:
            </label>
            <select
                id="existing-events"
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onSelect(e.target.value)}
                className="p-2 border border-gray-300 rounded-md w-[150px]"
                value={selectedValue}
            >
                {!isLoading ? (
                    <option value="">Vyberte akci</option>
                ) : (
                    <option value="">Načítání akce</option>
                )}
                {events.map((evt) => (
                    <option key={evt.id} value={evt.id}>
                        {evt.name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default EventSelectorComponent;
